import AssetLibrary from "../assets/asset-library";
import { listen } from "./events";

function initObjectUsers() {

    listen('delete_object', unassignObjectUsers);

}

function unassignObjectUsers({ uuid }) {

    unassignLightTarget(uuid);

}

function unassignLightTarget(objectUuid) {

    for (let lightUuid in Q3.data.assets.lights) {

        let lightData = Q3.data.assets.lights[lightUuid];

        if (lightData.targetUuid === objectUuid) {

            delete lightData.targetUuid;

            let light = AssetLibrary.lights[lightUuid];

            if (light) {

                light.target = new THREE.Object3D();

            }

        }

    }

}

export default initObjectUsers;
